/* eslint-disable react/jsx-no-constructed-context-values */
import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import type { PropsWithChildren } from 'react';
import React from 'react';
import { TrackingServiceContext } from './TrackingServiceContext';

export const TrackingServiceContextProvider: React.FC<
  {
    trackingService: TrackingServiceV2;
  } & PropsWithChildren
> = ({ trackingService, children }) => {
  return (
    <TrackingServiceContext.Provider value={{ trackingService }}>
      {children}
    </TrackingServiceContext.Provider>
  );
};

TrackingServiceContextProvider.displayName = 'TrackingServiceContextProvider';
